import api from "./api";

const bonafideService = {
  // GET /api/bonafide?search=&page=&limit=
  getAll: (params = {}) => api.get("/bonafide", { params }),

  // GET /api/bonafide/:id  (includes populated student)
  getById: (id) => api.get(`/bonafide/${id}`),

  // POST /api/bonafide
  create: (data) => api.post("/bonafide", data),

  // PUT /api/bonafide/:id
  update: (id, data) => api.put(`/bonafide/${id}`, data),

  // DELETE /api/bonafide/:id
  remove: (id) => api.delete(`/bonafide/${id}`),

  // GET /api/bonafide/preview-date?date=18/07/2006
  previewDate: (date) =>
    api.get("/bonafide/preview-date", { params: { date } }),
};

export default bonafideService;
